import {Dispatch} from 'react'
import { GESTION_USUARIO_TYPES } from '../../constants/gestionUsuario.types'
import { PerfilUsuarioAction } from '../../interfaces/perfil-usuario.interface'
import {State} from '../../reducers'
import {generalOpenModalError, generalOpenModalMessage, generalShowLoader} from '../general.actions'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import { updateUserLocalData, userLoginSave } from '../userLogin.actions'


export const perfilSetDataUsers = (perfil: any) => ({
  type: GESTION_USUARIO_TYPES.PF_FORM_HANDLE_PROFILE,
  payload: perfil,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************

// ******************************************************************************************
// ? PETICIONES REST
// ******************************************************************************************
export const changeSucursalSeleccionada = (sucursal: any, showModalResult:boolean = true) => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true))

  let message = 'No se logro cambiar la sucursal seleccionada.'
  const {datos} = getState().userLogin;
  const {id} = datos;
  
  const body = {id_user: id, id_sucursal: sucursal.id_sucursal};

  let sucursal_hora_inicio = "";
  let sucursal_hora_final = "";

  if (sucursal.SucursalHorarios?.length > 0) {
    const horarioActivo = sucursal.SucursalHorarios[0];
    sucursal_hora_inicio = horarioActivo.hora_inicio;
    sucursal_hora_final = horarioActivo.hora_final;
  }
 
  return await http
    .put(ENDPOINTS.PERFIL_USUARIO_CHANGE_SUCURSAL, body)
    .then(async(res: any) => {
      if (res?.status === 200) {
        dispatch(updateUserLocalData({...datos, sucursal_seleccionada: sucursal.id_sucursal, sucursal_hora_inicio, sucursal_hora_final}));
        await dispatch(perfilGetDataUser(datos.username));

        if (showModalResult) dispatch(generalOpenModalMessage("Cambio de sucursal", "La sucursal seleccionada para realizar operaciones ha sido actualizada exitosamente."))
      } else {
        dispatch(generalOpenModalError(res?.message ?? message))
      }
    })
    .catch((err: any) => {
      dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const perfilGetDataUser = (username: any) => async (dispatch: Dispatch<PerfilUsuarioAction>, getState: () => State) => {
    const message = 'No se logró obtener los datos del perfil'
    await http
      .get(ENDPOINTS.PERFIL_USUARIO_GET_USUARIO, {username: username}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.data && res.status === 200) {
          dispatch(perfilSetDataUsers(res.data))
          return
        }
        dispatch(generalOpenModalError(res.message || message))
      })
      .catch((err) => {
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
  }
